<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.coldChainEdit" type="confirm" width="40%" @confirm="confirm">
    <vxe-form ref="form" :data="order" :rules="rules" span="12">
      <vxe-form-item :item-render="{name:'VxeSelect',options:conveyances}" field="conveyance.id" title="business.label.conveyance"/>
      <vxe-form-item :item-render="{name:'VxeSelect',options:tempControlModes}" field="tempControlMode.id" title="business.label.tempControlMode"/>
      <vxe-form-item :item-render="{name:'VxeDatePicker',props:{type:'datetime'}}" field="departureTime" title="business.label.departureTime"/>
      <vxe-form-item :item-render="{name:'VxeDatePicker',props:{type:'datetime'}}" field="arrivalTime" title="business.label.arrivalTime"/>
      <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="temperature.departureTemp" title="business.label.departureTemp"/>
      <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="temperature.arrivalTemp" title="business.label.arrivalTemp"/>
      <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="temperature.maximumTemp" title="business.label.maximumTemp"/>
      <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="temperature.minimumTemp" title="business.label.minimumTemp"/>
    </vxe-form>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import { WAREHOUSE } from '@/store/mutation-types'
import { findOne, post } from '@/api/Api'
import { AsnOrder } from '@/api/dto/order/AsnOrder'
import { getDictionaries } from '@/utils/util'

export default {
  name: 'ColdChainEditor',
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new AsnOrder(),
      conveyances: [],
      tempControlModes: [],
      rules: {
        'conveyance.id': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'tempControlMode.id': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'temperature.departureTemp': [{ required: true, type: 'number', message: this.$t('message.cannotBeEmpty') }],
        'temperature.arrivalTemp': [{ required: true, type: 'number', message: this.$t('message.cannotBeEmpty') }],
        'temperature.maximumTemp': [{ required: true, type: 'number', message: this.$t('message.cannotBeEmpty') }],
        'temperature.minimumTemp': [{ required: true, type: 'number', message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  created() {
    getDictionaries('CONVEYANCE').then(result => {
      this.conveyances = result
      return getDictionaries('TEMP_CONTROL_MODE')
    }).then(result => {
      this.tempControlModes = result
    })
  },
  methods: {
    open(id) {
      this.visible = true
      this.loading = true
      findOne('asnOrderFactory', { id: id }).then(res => {
        if (res.success) {
          this.order = new AsnOrder(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const order = this.order.toJSONObject()
      order.warehouse = this.warehouse
      post(api.receivingAsnSave, { type: 'normalAsn' }, order).then(res => {
        if (res.success) {
          this.$emit('success', res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    async confirm() {
      if (!await this.$refs.form.validate()) this.save()
    }
  }
}
</script>